export { default as GenericEmbed } from './GenericEmbed';